import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Input,
  Label,
  FormGroup,
} from "reactstrap";

const Cadastrar = (props) => {
  // ** Const
  // ** Props
  const { open, setOpen, card, updateAba, maxSize } = props;
  const [aba, setAba] = useState({});
  const [ordemAba, setOrdemAba] = useState(0);

  useEffect(() => {
    console.log(ordemAba);
    if (updateAba) {
      setAba({
        name: card.abaTitulo,
        nameOld: card.abaTitulo,
        idAba: card.idAba,
        ordemAba: card.ordemAba,
      });
      setOrdemAba(card?.ordemAba);
    } else {
      setAba({
        name: "",
        ordemAba: maxSize + 1,
      });
      setOrdemAba(maxSize + 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [card, updateAba, open]);

  const handleSubmit = (e) => {
    e.preventDefault();
    let area = localStorage.getItem("area");
    let menus = JSON.parse(localStorage.getItem("menus"));
    let menuSelecionado = menus?.find(
      (item) =>
        // eslint-disable-next-line eqeqeq
        item.area == localStorage.getItem("area") &&
        // eslint-disable-next-line eqeqeq
        item.id == localStorage.getItem("idMenu")
    );
    //if (Number(aba.ordemAba) === ordemAba) {
    if (updateAba) {
      let model = {
        params: {
          arg1: area,
          arg2: menuSelecionado?.menu,
          arg3: card.titulo,
          arg4: aba.name,
          arg5: aba.nameOld,
          arg6: aba.ordemAba,
        },
      };
      props.updateTab(model);
    } else {
      let model = {
        params: {
          arg1: area,
          arg2: menuSelecionado?.menu,
          arg3: card.titulo,
          arg4: aba.name,
          arg5: aba.ordemAba,
        },
      };
      props.createTab(model);
    }
    // }
    // else {
    //   const from = ordemAba;
    //   const to = aba.ordemAba;
    //   aba.ordemAba = ordemAba;
    //   props.handleOrderAba(aba, Number(from), Number(to), !updateAba)
    // }
    setOpen(false);
  };

  return (
    <Modal
      isOpen={open}
      toggle={() => setOpen(!open)}
      className={`modal-dialog-centered`}
      size="lg"
    >
      <ModalHeader toggle={() => setOpen(!open)}>
        {updateAba ? "Atualizar" : "Cadastrar"} Aba{" "}
      </ModalHeader>
      <ModalBody>
        <Form id="form" className="mb-2">
          <FormGroup>
            <Label for="nome">Título</Label>
            <Input
              type="text"
              id="name"
              placeholder="Título"
              value={aba.name}
              name="name"
              onChange={(e) =>
                setAba({
                  ...aba,
                  [e.target.name]: e.target.value,
                })
              }
            />
          </FormGroup>
          <FormGroup>
            <Label for="ordem">Ordem</Label>
            <Input
              type="number"
              min={1}
              id="ordemAba"
              placeholder="Ordenação no card"
              value={aba.ordemAba}
              name="ordemAba"
              onChange={(e) => {
                const value =
                  e.target.value < 1 ? aba.ordemAba : e.target.value;
                setAba({
                  ...aba,
                  [e.target.name]: value,
                });
              }}
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button type="submit" onClick={(e) => handleSubmit(e)} color="primary">
          {updateAba ? "Atualizar" : "Cadastrar"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default Cadastrar;
